import { Action, createReducer, on, State } from "@ngrx/store";
import {
  loadLoanApplicationByIdSuccess,
  loadLoanApplicationError,
  loadLoanApplicationSuccess,
  updateLoanApplicationSuccess
} from "./loanapplication.actions";
import { LoanApplication } from "../app/data/schema/loan-appication/loan-application";

export interface LoanApplicationState {
  [id: string]: LoanApplication;
}

export const loanApplicationFeatureKey = "loanApplication";

export interface LoanApplicationRootState {
  [loanApplicationFeatureKey]: LoanApplicationState;
}

const initialState: LoanApplicationState = { loanApp: null };

const reducer = createReducer(
  initialState,
  on(loadLoanApplicationSuccess, (state, { loanApplications }) =>
    loanApplications.reduce(
      (acc, loanApplication) => ({
        ...acc,
        [loanApplication.id]: loanApplication
      }),
      {}
    )
  ),

  on(updateLoanApplicationSuccess, (state, { loanApplication }) => ({
    ...state,
    [loanApplication.id]: loanApplication
  }))
);

export function loanApplicationReducer(
  state: LoanApplicationState | undefined,
  action: Action
) {
  return reducer(state, action);
}
